import { render, staticRenderFns } from "./Specifications.vue?vue&type=template&id=6d175e35&"
import script from "./Specifications.vue?vue&type=script&lang=ts&"
export * from "./Specifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports